<template>
  <a-modal
    width="800px"
    title="确认计算结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，
      <span v-if="calculationAbnormal.length" style="color: red;">部分结果异常或有误，建议返回检查</span>
      <span v-else>计算结果如下</span>:
    </div>
    <br>
    <h3>生产结果</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span class="title">成活率（%）</span>
          <a-icon v-if="isAbnormal('survivalRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('survivalRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.survivalRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span >料肉比</span>
          <a-icon v-if="isAbnormal('weightCostRatio')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('weightCostRatio') ? 'abnormalBox' : 'box'">
            {{calculationResult.weightCostRatio?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段总耗料（kg）</span>
          <a-icon v-if="isAbnormal('stageFeedCostTotal')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageFeedCostTotal') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageFeedCostTotal?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>阶段总增重（kg）</span>
          <a-icon v-if="isAbnormal('stageIncrementWeightTotal')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('stageIncrementWeightTotal') ? 'abnormalBox' : 'box'">
            {{calculationResult.stageIncrementWeightTotal?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>平均日采食量（kg/头）</span>
          <a-icon v-if="isAbnormal('avgFeedCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgFeedCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgFeedCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>平均日增重（kg/头）</span>
          <a-icon v-if="isAbnormal('avgWeightIncrement')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgWeightIncrement') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgWeightIncrement?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    <br>
    <h3>经济效益</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span>卖猪头均收入（元）</span>
          <a-icon v-if="isAbnormal('avgSaleProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgSaleProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgSaleProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>造肉成本（元/kg）</span>
          <a-icon v-if="isAbnormal('mealProductCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('mealProductCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.mealProductCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>头均纯效益（元）</span>
          <a-icon v-if="isAbnormal('avgNetProfit')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('avgNetProfit') ? 'abnormalBox' : 'box'">
            {{calculationResult.avgNetProfit?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    </a-modal>
</template>

<script>
export default {
  props:['visible','calculationResult','calculationAbnormal'],
  data(){
    return{}
  },
  methods:{
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('calculationConfirm')
    },
    handleCancel() {
      this.$emit('calculationAbnormalInit')
      this.$emit('isShow', false)
    },
    isAbnormal(value){
      return this.calculationAbnormal.includes(value)
    }
  }
}
</script>

<style lang='scss'>
.result{
  background-color:whitesmoke;
  padding: 3px;
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
  .abnormalBox{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
    color: red;
  }
  .anticon{
    color: orange 
  }
}
</style>